import { userExistsRequest } from '../api/users';
import { VYCE_EMAIL } from '../constants';
import { AppNotification } from '../types';

export const checkNINumber = async (
  ni_number: string,
  recaptcha_token: string,
  showNotification: (notification: AppNotification) => void
): Promise<boolean> => {
  let isNINumberAvailable: boolean;
  try {
    const res = await userExistsRequest({ ni_number, recaptcha_token });
    isNINumberAvailable = !res.data?.ni_number_exists;
  } catch (e) {
    isNINumberAvailable = false;
    console.error(e);
  }
  if (!isNINumberAvailable) {
    const notification = getErrorObject('NI Number');
    showNotification(notification);
  }
  return isNINumberAvailable;
};

export const checkPhoneNumber = async (
  phone: string,
  recaptcha_token: string,
  showNotification: (notification: AppNotification) => void
): Promise<boolean> => {
  let isAvailable: boolean;
  try {
    const res = await userExistsRequest({ phone, recaptcha_token });
    isAvailable = !res.data?.phone_exists;
  } catch (e) {
    isAvailable = false;
    console.error(e);
  }
  if (!isAvailable) {
    const notification = getErrorObject('Phone Number');
    showNotification(notification);
  }
  return isAvailable;
};

const getErrorObject = (param: string): AppNotification => {
  return {
    message: `Hmmm. This ${param} is already registered on Vyce.`,
    description: `Please check to make sure your ${param} is correct. If this is your ${param} and it is not associated to your account, please <a class="not-app-link" href="mailto: ${VYCE_EMAIL}" target="_blank">get in touch</a> and we’ll look into it ASAP.`,
    options: {
      variant: 'error',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center',
      },
      action: {
        type: null,
        buttonText: '',
      },
      permanent: true,
    },
  };
};
